
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"48","rx":"5","fill":"#E8F3DB"}}),_c('path',{attrs:{"d":"M33 23h-1v-1a1 1 0 00-2 0v1h-1a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2zm-7.7 1.72A4.92 4.92 0 0027 21a5 5 0 10-10 0 4.92 4.92 0 001.7 3.72A8 8 0 0014 32a1 1 0 002 0 6 6 0 1112 0 1 1 0 002 0 8 8 0 00-4.7-7.28zM22 24a3 3 0 110-5.999A3 3 0 0122 24z","fill":"#009918"}})])
          )
        }
      }
    